import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight, BookOpen } from "lucide-react";
import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";
import { getResources } from "../lib/api";
import config from "../config/stateConfig";

export default function Resources() {
  const [resources, setResources] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getResources().then(setResources).catch(() => setResources([])).finally(() => setLoaded(true));
  }, []);

  return (
    <>
      <SEO
        title={`${config.stateName} Accident Resources | Evergreen Legal & Claims Library`}
        description={`Authoritative ${config.stateName} accident and injury reference guides: statutes, insurance rules, settlements, and claims answers that stay useful for years.`}
      />
      <section className="pt-12 md:pt-20 pb-12 px-6 bg-bone">
        <div className="max-w-7xl mx-auto">
          <div className="overline mb-3">Resource Library</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5 text-balance max-w-3xl">
            The {config.stateName} accident & injury reference library.
          </h1>
          <p className="text-lg text-charcoal-soft max-w-2xl">
            Authoritative, evergreen guides to {config.stateName} law, insurance, and the claims
            process — the reference we wish every accident victim had.
          </p>
        </div>
      </section>

      <section className="px-6 pb-20">
        <div className="max-w-7xl mx-auto">
          {loaded && resources.length === 0 && (
            <div className="text-center py-16 text-charcoal-soft" data-testid="resources-empty">
              Our reference library is being written — check back very soon.
            </div>
          )}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {resources.map((r) => (
              <Link
                key={r.id}
                to={`/resources/${r.slug}`}
                className="card-elevated p-7 group flex flex-col"
                data-testid={`resource-card-${r.slug}`}
              >
                <div className="w-11 h-11 rounded-xl bg-terracotta/10 text-terracotta grid place-items-center mb-4">
                  <BookOpen className="w-5 h-5" />
                </div>
                <h3 className="font-display font-bold text-xl text-forest mb-2 leading-tight group-hover:text-terracotta transition-colors">
                  {r.title}
                </h3>
                <p className="text-sm text-charcoal-soft leading-relaxed flex-1">{r.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-terracotta mt-4">
                  Read guide <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
